import { AddressTranslations } from './types';

export const defaultTranslations: AddressTranslations = {
  country: {
    label: 'Country',
    placeholder: 'Select country',
  },
  city: {
    label: 'City',
    placeholder: 'City',
  },
  address: {
    label: 'Street Address 1',
    placeholder: 'Street, Number, Apt./Suite',
  },
  address2: {
    label: 'Street Address 2',
    placeholder: 'Street, Number, Apt./Suite',
  },
  state: {
    label: 'State',
    placeholder: 'Select state',
  },
  zip: {
    label: 'ZIP Code',
    placeholder: '00000',
  },
  postalCode: {
    label: 'Postal Code',
    placeholder: '00000',
  },
  region: {
    label: 'State / Region',
    placeholder: 'Select state',
  },
  error: {
    invalid: 'This field is invalid',
    required: 'This field is required',
  },
  input: {
    selectOptionLabel: 'Select value',
    searchLabel: 'Type to search',
  },
};
